module.exports = __webpack_public_path__ + "static/media/RaisingChildren_android_2_preview.6fa073f2.jpg";